/*
 * Intelligems A/B — subscription facade + qty chrome (fail-closed, all markets).
 *
 * ONLY Intelligems Variant JS should turn this on (Immediate timing):
 *   window.abShroomsRcVariant = true;
 *   if (window.abShroomsRc) window.abShroomsRc.activate();
 *
 * Control / live: leave IG CSS/JS empty. Stock Recharge is never pre-hidden.
 * Variant: flag trap adds pending; activate() shows facade + sets
 * TW_RC_SKIP_FLEX_CHROME. Free gifts only on UK (gifts source template is
 * UK custom PDP only) when #tw-rc-subscription-gifts-source has cards.
 */

(function () {
  'use strict';

  var HTML_CLASS = 'ab-shrooms-rc';
  var PENDING_CLASS = 'ab-shrooms-rc-pending';
  var FACADE_ID = 'ab-shrooms-rc-facade';
  var FLAG_KEY = 'abShroomsRcVariant';
  var RESOLVE_ATTEMPTS = 70;

  var SEL = {
    widget: 'recharge-subscription-widget',
    tileBadge: '.quantity-save-badge[data-option-index]',
    tileList: '[class*="__list"]',
    sellingPlan: 'form[action*="/cart/add"] input[name="selling_plan"]',
    giftsSource: '#tw-rc-subscription-gifts-source',
    giftsMount: '[data-ab-shrooms-rc-gifts]',
    giftsGrid: '[data-ab-shrooms-rc-gifts-grid]',
    subCard: '[data-ab-shrooms-rc-option="subscription"]',
    otpCard: '[data-ab-shrooms-rc-option="onetime"]',
    saveBadge: '[data-ab-shrooms-rc-save]',
    subCompare: '[data-ab-shrooms-rc-sub-compare]',
    subPrice: '[data-ab-shrooms-rc-sub-price]',
    otpPrice: '[data-ab-shrooms-rc-otp-price]',
    details: '[data-ab-shrooms-rc-details]',
    deliversTitle: '[data-ab-shrooms-rc-delivers-title]',
    quickBuy: '.wt__quick-buy',
    pdpRoot: '.wt-product__wrapper',
  };

  var _bound = false;
  var _activated = false;
  var _syncTimer = null;
  var _pollTimer = null;

  /**
   * Quick buy copies PDP HTML — never bind AB to the drawer.
   * @param {Element|null} el
   * @returns {boolean}
   */
  function isInQuickBuy(el) {
    return !!(el && el.closest && el.closest(SEL.quickBuy));
  }

  /**
   * Prefer the main PDP facade; ignore any copy still inside quick buy.
   * @returns {HTMLElement|null}
   */
  function getFacade() {
    var el = document.getElementById(FACADE_ID);
    if (el && !isInQuickBuy(el)) return el;

    var facades = document.querySelectorAll('[data-ab-shrooms-rc-facade]');
    for (var i = 0; i < facades.length; i++) {
      if (!isInQuickBuy(facades[i])) return facades[i];
    }
    return null;
  }

  function isVariantSignal() {
    return window[FLAG_KEY] === true;
  }

  /**
   * Recharge widget on the main PDP only (not quick buy).
   * @returns {Element|null}
   */
  function getWidget() {
    var root = document.querySelector(SEL.pdpRoot);
    if (root) {
      var inPdp = root.querySelector(SEL.widget);
      if (inPdp) return inPdp;
    }

    var widgets = document.querySelectorAll(SEL.widget);
    for (var i = 0; i < widgets.length; i++) {
      if (!isInQuickBuy(widgets[i])) return widgets[i];
    }
    return null;
  }

  function clearPending() {
    document.documentElement.classList.remove(PENDING_CLASS);
    if (
      window.abShroomsRc &&
      typeof window.abShroomsRc.releasePending === 'function'
    ) {
      window.abShroomsRc.releasePending();
    }
  }

  function getWidgetShadow() {
    var widget = getWidget();
    return widget && widget.shadowRoot ? widget.shadowRoot : null;
  }

  function getActiveBadge() {
    var badges = document.querySelectorAll(SEL.tileBadge);
    var firstPdp = null;
    for (var i = 0; i < badges.length; i++) {
      if (isInQuickBuy(badges[i])) continue;
      if (!firstPdp) firstPdp = badges[i];
      var label = badges[i].closest('label');
      if (!label) continue;
      var input = document.getElementById(label.getAttribute('for'));
      if (input && input.checked) return badges[i];
    }
    return firstPdp;
  }

  /**
   * Month count from active tile supply text ("2 months supply" → 2).
   * @param {HTMLElement|null} badge
   * @returns {number}
   */
  function getDeliveryMonths(badge) {
    if (!badge) return 1;
    var label = badge.closest('label');
    if (!label) return 1;

    var supply =
      label.querySelector('[data-option-description]') ||
      label.querySelector('.option_selector_desc__supply');
    if (!supply) return 1;

    var match = String(supply.textContent || '')
      .toLowerCase()
      .match(/(\d+)\s*months?/);
    if (!match) return 1;

    var months = parseInt(match[1], 10);
    return months > 0 ? months : 1;
  }

  function formatDeliversTitle(months) {
    if (months <= 1) return 'Delivers Monthly';
    return 'Delivers every ' + months + ' months';
  }

  function isSubscriptionSelected() {
    var plans = document.querySelectorAll(SEL.sellingPlan);
    var sellingPlan = null;
    for (var i = 0; i < plans.length; i++) {
      if (!isInQuickBuy(plans[i])) {
        sellingPlan = plans[i];
        break;
      }
    }
    if (sellingPlan) return String(sellingPlan.value || '').trim() !== '';

    var shadow = getWidgetShadow();
    if (!shadow) return true;

    var checked = shadow.querySelector('input[name="purchaseOption"]:checked');
    if (!checked) return true;

    var value = String(checked.value || '').toLowerCase();
    return value === 'subscription' || value.indexOf('sub') === 0;
  }

  /**
   * @param {'subscription'|'onetime'} option
   * @returns {HTMLInputElement|null}
   */
  function findPurchaseOptionInput(option) {
    var shadow = getWidgetShadow();
    if (!shadow) return null;

    var inputs = shadow.querySelectorAll('input[name="purchaseOption"]');
    if (!inputs.length) return null;

    var wantSub = option === 'subscription';
    for (var i = 0; i < inputs.length; i++) {
      var value = String(inputs[i].value || '').toLowerCase();
      var isSub = value === 'subscription' || value.indexOf('sub') === 0;
      var isOtp =
        value === 'onetime' ||
        value === 'one-time' ||
        value === 'otp' ||
        value.indexOf('one') === 0;

      if (wantSub && isSub) return inputs[i];
      if (!wantSub && isOtp) return inputs[i];
    }

    return wantSub ? inputs[0] : inputs[1] || null;
  }

  /**
   * Click Recharge's radio — do not write selling_plan ourselves.
   * @param {'subscription'|'onetime'} option
   */
  function selectPurchaseOption(option) {
    var input = findPurchaseOptionInput(option);
    if (!input) return;

    if (input.checked) {
      syncFacadeFromState();
      return;
    }

    input.click();
    setTimeout(syncFacadeFromState, 80);
    setTimeout(syncFacadeFromState, 350);
  }

  function mountGifts() {
    var facade = getFacade();
    if (!facade) return;

    var mount = facade.querySelector(SEL.giftsMount);
    if (!mount) return;

    var template = document.querySelector(SEL.giftsSource);
    var grid =
      template &&
      ((template.content &&
        template.content.querySelector('.tw-rc-subscription-gifts__grid')) ||
        template.querySelector('.tw-rc-subscription-gifts__grid'));
    var cards = grid
      ? grid.querySelectorAll('.tw-rc-subscription-gifts__card')
      : [];
    var target = mount.querySelector(SEL.giftsGrid);

    if (!cards.length || !target) {
      mount.hidden = true;
      return;
    }

    target.innerHTML = '';

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var img = card.querySelector('img');
      var titleEl = card.querySelector('.tw-rc-subscription-gifts__title');
      var li = document.createElement('li');
      li.className = 'ab-shrooms-rc__gift-card';

      if (img) {
        var imgClone = img.cloneNode(true);
        imgClone.className = 'ab-shrooms-rc__gift-img';
        imgClone.removeAttribute('width');
        imgClone.removeAttribute('height');

        var wrap = document.createElement('span');
        wrap.className = 'ab-shrooms-rc__gift-img-wrap';
        wrap.appendChild(imgClone);
        li.appendChild(wrap);
      }

      var title = document.createElement('span');
      title.className = 'ab-shrooms-rc__gift-title';
      title.textContent = titleEl ? titleEl.textContent.trim() : '';
      li.appendChild(title);
      target.appendChild(li);
    }

    mount.hidden = false;
    mount.setAttribute('data-ab-gift-count', String(cards.length));
  }

  function stripCurrencyCode(text) {
    return String(text || '').replace(/\s+[A-Z]{3}\s*$/g, '').trim();
  }

  function setText(el, text) {
    if (!el) return;
    if (text) {
      el.textContent = text;
      el.hidden = false;
    } else {
      el.textContent = '';
    }
  }

  function syncFacadeFromState() {
    var facade = getFacade();
    if (!facade) return;

    var badge = getActiveBadge();
    var isSub = isSubscriptionSelected();

    facade.setAttribute(
      'data-ab-purchase',
      isSub ? 'subscription' : 'onetime',
    );

    var subBtn = facade.querySelector(SEL.subCard);
    var otpBtn = facade.querySelector(SEL.otpCard);

    if (subBtn) {
      subBtn.setAttribute('aria-pressed', isSub ? 'true' : 'false');
      subBtn.classList.toggle('ab-shrooms-rc__card--selected', isSub);
    }

    if (otpBtn) {
      otpBtn.setAttribute('aria-pressed', isSub ? 'false' : 'true');
      otpBtn.classList.toggle('ab-shrooms-rc__card--selected', !isSub);
    }

    var details = facade.querySelector(SEL.details);
    if (details) details.hidden = !isSub;

    var deliversTitle = facade.querySelector(SEL.deliversTitle);
    if (deliversTitle) {
      deliversTitle.textContent = formatDeliversTitle(getDeliveryMonths(badge));
    }

    if (!badge) return;

    var saveMoney = (
      badge.getAttribute('data-save-money-subscription') || ''
    ).trim();
    var saveEl = facade.querySelector(SEL.saveBadge);

    if (saveEl) {
      if (saveMoney) {
        saveEl.textContent = 'You save ' + saveMoney;
        saveEl.hidden = false;
      } else {
        saveEl.textContent = '';
        saveEl.hidden = true;
      }
    }

    var compare =
      (badge.getAttribute('data-compare-at-display') || '').trim() ||
      (badge.getAttribute('data-full-price') || '').trim();

    setText(
      facade.querySelector(SEL.subCompare),
      stripCurrencyCode(compare),
    );
    setText(
      facade.querySelector(SEL.subPrice),
      stripCurrencyCode((badge.getAttribute('data-sns-price') || '').trim()),
    );
    setText(
      facade.querySelector(SEL.otpPrice),
      stripCurrencyCode(
        (badge.getAttribute('data-onetime-price') || '').trim(),
      ),
    );

    ensureQtyControlCopy();
  }

  function scheduleSync() {
    clearTimeout(_syncTimer);
    _syncTimer = setTimeout(syncFacadeFromState, 60);
  }

  function bindFacadeEvents() {
    if (_bound) return;

    var facade = getFacade();
    if (!facade) return;

    _bound = true;

    facade.addEventListener('click', function (e) {
      var btn =
        e.target && e.target.closest
          ? e.target.closest('[data-ab-shrooms-rc-option]')
          : null;
      if (!btn || !facade.contains(btn)) return;

      var option = btn.getAttribute('data-ab-shrooms-rc-option');
      if (option === 'subscription' || option === 'onetime') {
        selectPurchaseOption(option);
      }
    });

    document.addEventListener('change', function (e) {
      if (!e.target) return;

      if (
        e.target.closest &&
        e.target.closest(SEL.tileList) &&
        e.target.name !== 'selling_plan' &&
        e.target.name !== 'rc_plan'
      ) {
        scheduleSync();
        setTimeout(scheduleSync, 200);
      }

      if (
        e.target.name === 'selling_plan' ||
        e.target.name === 'purchaseOption'
      ) {
        scheduleSync();
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest(SEL.widget)) return;

      setTimeout(scheduleSync, 80);
      setTimeout(scheduleSync, 350);
    });
  }

  /**
   * Qty tiles: Multibuy IG may hide .ab-mb-control-group while this AB hides
   * .ab-mb-value-group — both gone ⇒ blank tiles (badge + image only).
   * Force control copy with inline !important (beats late IG CSS). PDP only.
   */
  function ensureQtyControlCopy() {
    var root = document.querySelector(SEL.pdpRoot) || document;
    var options = root.querySelectorAll(
      '.wt-product__option:has(.quantity-save-badge)'
    );

    for (var o = 0; o < options.length; o++) {
      if (isInQuickBuy(options[o])) continue;

      var controls = options[o].querySelectorAll('.ab-mb-control-group');
      for (var i = 0; i < controls.length; i++) {
        var el = controls[i];
        var isBadge = el.classList.contains('quantity-save-badge');
        el.style.setProperty(
          'display',
          isBadge ? 'flex' : 'block',
          'important'
        );
        el.style.setProperty('visibility', 'visible', 'important');
        el.style.setProperty('opacity', '1', 'important');
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('max-height', 'none', 'important');
        el.style.setProperty('overflow', 'visible', 'important');
        el.style.setProperty('position', 'static', 'important');
        el.style.setProperty('clip', 'auto', 'important');
        el.style.setProperty('clip-path', 'none', 'important');
        if (!isBadge) {
          el.style.setProperty('color', '#262422', 'important');
          el.style.setProperty('font-size', '14px', 'important');
          el.style.setProperty('line-height', '1.2', 'important');
        }
      }

      var values = options[o].querySelectorAll('.ab-mb-value-group');
      for (var v = 0; v < values.length; v++) {
        values[v].style.setProperty('display', 'none', 'important');
      }

      var descs = options[o].querySelectorAll('.option_selector_desc');
      for (var d = 0; d < descs.length; d++) {
        descs[d].style.setProperty('display', 'flex', 'important');
        descs[d].style.setProperty('visibility', 'visible', 'important');
        descs[d].style.setProperty('opacity', '1', 'important');
        descs[d].style.setProperty('overflow', 'visible', 'important');
        descs[d].style.setProperty('height', 'auto', 'important');
      }

      var links = options[o].querySelectorAll('.f-button__list__link');
      for (var l = 0; l < links.length; l++) {
        links[l].style.setProperty('overflow', 'visible', 'important');
        links[l].style.setProperty('height', 'auto', 'important');
        links[l].style.setProperty('max-height', 'none', 'important');
      }
    }
  }

  function activateVariant() {
    if (_activated) return;

    window[FLAG_KEY] = true;
    /* Variant only — never set this on Control or Flexible Plan breaks */
    window.TW_RC_SKIP_FLEX_CHROME = true;

    if (!getFacade()) {
      watchForVariantSignal();
      return;
    }

    _activated = true;
    clearInterval(_pollTimer);
    _pollTimer = null;

    document.documentElement.classList.add(HTML_CLASS);
    clearPending();
    ensureQtyControlCopy();
    setTimeout(ensureQtyControlCopy, 100);
    setTimeout(ensureQtyControlCopy, 500);
    setTimeout(ensureQtyControlCopy, 1500);
    setTimeout(ensureQtyControlCopy, 3000);

    var facade = getFacade();
    facade.hidden = false;
    facade.removeAttribute('hidden');

    var widget = getWidget();
    if (widget) {
      widget.setAttribute('aria-hidden', 'true');
      widget.setAttribute('data-ab-shrooms-rc-hidden', 'true');
    }

    mountGifts();
    bindFacadeEvents();

    function bootSync(attempt) {
      attempt = attempt || 0;
      syncFacadeFromState();
      ensureQtyControlCopy();

      if (!getWidgetShadow() && attempt < 40) {
        setTimeout(function () {
          bootSync(attempt + 1);
        }, 100);
        return;
      }

      if (!isSubscriptionSelected()) {
        selectPurchaseOption('subscription');
      } else {
        syncFacadeFromState();
      }
    }

    bootSync(0);
  }

  function watchForVariantSignal() {
    if (_activated) return;
    if (isVariantSignal() && getFacade()) {
      activateVariant();
      return;
    }

    if (_pollTimer) return;

    var attempts = 0;
    _pollTimer = setInterval(function () {
      attempts += 1;

      if (isVariantSignal() && getFacade()) {
        activateVariant();
        return;
      }

      /* Control / live: reveal stock Recharge; stop polling */
      if (attempts >= RESOLVE_ATTEMPTS) {
        clearInterval(_pollTimer);
        _pollTimer = null;
        if (!_activated) clearPending();
      }
    }, 100);
  }

  /**
   * Quick buy clones PDP HTML. Strip our AB root there so stock Recharge
   * stays untouched — keeps teardown out of quick-add.js.
   */
  function stripAbRootFromQuickBuy() {
    var drawer = document.querySelector(SEL.quickBuy);
    if (!drawer) return;

    var nodes = drawer.querySelectorAll('[data-ab-shrooms-rc-root]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].remove();
    }
  }

  function watchQuickBuyForAbRoot() {
    stripAbRootFromQuickBuy();

    var drawer = document.querySelector(SEL.quickBuy);
    if (!drawer || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      stripAbRootFromQuickBuy();
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  function boot() {
    document.addEventListener('ab-shrooms-rc:activate', function () {
      window[FLAG_KEY] = true;
      activateVariant();
    });

    watchQuickBuyForAbRoot();
    watchForVariantSignal();
  }

  window.abShroomsRc = Object.assign(window.abShroomsRc || {}, {
    activate: activateVariant,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
